(function(w, $) {
    const assetId = '~/Controls/Menu/ViewPage.min.js';

    if (!w.umwAssets || !w.umwAssets[assetId]) {
        console.error('No context found for ' + assetId);
        return;
    }

    for (let ctx of w.umwAssets[assetId]) {
        $(function() {
            var cont = $('#' + ctx.pnlMainId);

            cont.find('.MainTitleContainer').on("click",
                function() {
                    cont.find('.Content').slideToggle("fast");
                });
        });
    }
})(window, jQuery);